import { compose, set, lensProp } from 'ramda';
import { formatterClients } from '../../../helpers/formatters';

import {
  SET_CLIENT,
  SET_ALL_CLIENTS,
  SELECT_CLIENT,
  HANDLE_LOADING,
  SET_CLIENTS_FILTER
} from './constants';

const defaultState = {
  clients: [],
  allClients: [],
  total: 0,
  isLoading: false,
  isDetailing: false,
  clientTypeId: null,
  clientsQp: '',
  clientsPage: 1
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_CLIENT: {
      const clients = compose(
        set(lensProp('isLoading'), false),
        set(lensProp('total'), action.total),
        set(lensProp('clients'), formatterClients(action.data))
      );

      return clients(state);
    }
    case SET_ALL_CLIENTS: {
      return {
        ...state,
        allClients: action?.data
      }
    }
    case SELECT_CLIENT: {
      return set(lensProp('clientTypeId'), action.clientTypeId, state);
    }
    case HANDLE_LOADING: {
      return set(lensProp('isLoading'), action.status, state);
    }
    case SET_CLIENTS_FILTER: {
      return {
        ...state,
        clientsQp: action?.data?.qp,
        clientsPage: action?.data?.page
      }
    }
    default: {
      return state;
    }
  }
}